<template>
    <div class="content__body">
        <div class="profile-info">
            <div class="profile-info__header">
                <div>Вы можете переключаться между дилерскими центрами, которые входят в состав холдинга.</div>
                <div>В случае отсутствия нужного ДЦ — обратитесь к администратору системы.</div>
            </div>

            <UILoader v-if="isCurrentUserDealersLoading" class="tableable" />

            <div v-else class="profile-info__body">
                <DataTable
                    :headers="headers"
                    :data="dealers"
                    has-actions
                >
                    <template #actions="{ row }">
                        <div v-if="row.id === getCurrentUser().dealer_id" class="profile-info-dealers__selected">
                            Выбран сейчас
                        </div>

                        <UISimpleButton
                            v-else
                            button-type="outlined"
                            class="profile-info__body-button"
                            @clicked="handleChangeCurrentDealer(row as DealerListItem)"
                        >
                            Переключиться
                        </UISimpleButton>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { h, inject, onMounted, ref } from 'vue';

    import { ModalPlugin } from '@/plugins/modalPlugin.ts';

    import { DealerListItem } from '@/types/dealer.type.ts';

    import useUserRepository from '@/repositories/user/useUserRepository.ts';

    import DataTable from '@/components/shared/DataTable/DataTable.vue';

    import UILoader from '@/components/ui/UILoader/UILoader.vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    import ConfirmActionModal from '@/components/modals/ConfirmActionModal/ConfirmActionModal.vue';

    import UserConfirmChangeCurrentDealer from '@/components/profile/UserConfirmChangeCurrentDealer/UserConfirmChangeCurrentDealer.vue';

    const $modal = inject('$modal') as typeof ModalPlugin;

    const { isCurrentUserDealersLoading, getCurrentUser, getCurrentUserDealers, changeUserCurrentDealer } = useUserRepository();

    const dealers = ref<DealerListItem[]>([]);
    const headers = ref([
        { label: 'Код дилера', key: 'sap_code' },
        { label: 'Название ДЦ', key: 'name' },
        { label: 'Холдинг', key: 'holding_name' },
        { label: 'Город', key: 'city_name' },
    ]);

    function handleChangeCurrentDealer(dealer: DealerListItem): void {
        $modal.open({
            component: ConfirmActionModal,
            modalType: 'narrow',
            slots: {
                default: () =>
                    h(UserConfirmChangeCurrentDealer, { dealer }),
            },
            props: {
                onConfirm: async () => {
                    await changeUserCurrentDealer(dealer.id);
                    fetchDealers();
                },
            },
        });
    }

    function fetchDealers(): void {
        getCurrentUserDealers().then((fetchedDealers: DealerListItem[]) => {
            dealers.value = fetchedDealers;
        });
    }

    onMounted(() => {
        fetchDealers();
    });
</script>

<style scoped lang="scss">
    @use 'DealersTab' as *;
</style>
